import type {
  CheckoutPageTextBlockFragment,
  TextblockByNameQuery,
} from "@server/gql/graphql";
import type { ReactNode, RefObject } from "react";
import { createContext } from "react";
import type { Dictionary } from "types";

import type { MarketAwareSlug } from "@/utils/const";

type CheckoutContextProps = {
  details: MarketAwareSlug;
  dictionary: Dictionary;
  madeToOrderBlock?: TextblockByNameQuery;
  eurobonusBlock?: CheckoutPageTextBlockFragment;
  deliveryStepRef?: RefObject<HTMLFormElement | null>;
  paymentStepRef?: RefObject<HTMLDivElement | null>;
  adyenDropInRef?: RefObject<HTMLDivElement | null>;
  walleyWidgetRef?: RefObject<HTMLDivElement | null>;
};

export type CheckoutProviderProps = CheckoutContextProps & {
  children: ReactNode;
};

export const CheckoutContext = createContext<CheckoutContextProps | undefined>(
  undefined,
);
